<template>
  <v-dialog v-model="isDeleteTransportOpen" width="98%" max-width="350px">
    <v-col>
      <v-card align="center" class="pa-4">
        <h2>Annuler ma planification</h2>
        <v-col>
          <v-row>
            <v-col>
              <v-btn color="#66BB6A" style="color: white" @click="deleteTransport()">
                Oui
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                color="red"
                style="color: white"
                @click="isDeleteTransportOpen = false"
              >
                Non
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-col>
  </v-dialog>
  <div style="width: 100%" align="center">
    <v-card
      class="pa-2"
      color="#ECEFF1"
      style="font-weight: 600; overflow: auto; height: 90vh"
      align="center"
    >
      <v-btn
        icon="mdi-delete"
        @click="isDeleteTransportOpen = true"
        color="red"
        style="position: absolute; right: 10px"
      >
      </v-btn>
      <v-col>
        <v-row justify="center" class="mb-3">
          <v-col align="left" cols="6" class="px-0">
            <div
              v-if="agency"
              class="pa-2"
              style="background-color: white; border: solid 1px lightgrey; height: 100%"
              align="center"
            >
              <div align="left" style="font-size: 20px">Informations agence</div>
              <div align="left" class="mt-3">
                <div v-for="key in getAgencyDataToShow" :key="key">
                  <div v-if="key == 'ag_cp'">
                    {{ agency[key] }}
                    {{ agency["ag_ville"] }}
                  </div>
                  <div v-else>
                    {{ agency[key] }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="6" align="center">
            <div
              class="pa-2"
              v-if="contratData"
              style="
                font-weight: bold;
                border: solid 1px lightgrey;
                border-radius: 0px;
                height: 100%;
                background-color: white;
                font-size: 15px;
              "
            >
              <div align="left" style="font-size: 20px">Informations Livraison</div>
              <div align="left" class="mt-3">
                <div>Client : {{ eventsData[0]["CLD_CLIENT_RAISON_SOCIALE"] }}</div>
                <div v-for="(keysTab, idx) in getContraDataToShowOnTheTop" :key="idx">
                  <div v-if="keysTab.length == 1">
                    {{ keysTab[0].name }} : {{ contratData[keysTab[0].key] }}
                  </div>
                  <div v-else>
                    {{ keysTab[0].name }} : {{ contratData[keysTab[0].key] }}
                    {{ contratData[keysTab[1].key] }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pa-0 mb-2"
            style="border: solid 1px lightgrey; background-color: white"
            align="center"
          >
            <h2 class="ma-0 darkBackground">Information Location</h2>
          </v-col>
          <v-col class="" style="border: solid 1px lightgrey">
            <v-row class="">
              <v-col
                cols="6"
                class="pr-0"
                style="border-right: solid 1px lightgrey; background-color: white"
              >
                <v-card
                  align="left"
                  v-if="contratData"
                  variant="text"
                  height="100%"
                  class="pa-2"
                >
                  Dossier suivie par : {{ contratData["CL_SUIVI_PAR"] }} <br />
                  Référence à rappeler : {{ contratData["CL_NUM_CONTRAT"] }}
                </v-card>
              </v-col>
              <v-col cols="6" class="pl-0" style="background-color: white">
                <v-card
                  align="left"
                  v-if="contratData"
                  variant="text"
                  height="100%"
                  class="pa-2"
                >
                  Compte Client : {{ contratData["CL_CLIENT_COMPTE"] }} <br />
                  Réf. Cde Client : {{ contratData["CL_REF_COMMANDE"] }} <br />
                  Référence Chantier : {{ contratData["CL_REF_CHANTIER"] }} <br />
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="mt-3 px-1" cols="12">
            <v-row>
              <v-col class="px-2 py-0">
                <v-table style="width: 100%; border: solid 1px lightgrey">
                  <thead>
                    <tr class="darkBackground">
                      <th class="form-div" style="border-right: solid 1px lightgrey">
                        Livraison
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="form-div" style="border-right: solid 1px lightgrey">
                        {{
                          convertToFrDateFomat(
                            eventsData[0]["CLD_DATE_LIVRAISON_DEPART"],
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </v-col>
              <v-col class="px-2 py-0">
                <v-table style="width: 100%; border: solid 1px lightgrey">
                  <thead>
                    <tr class="darkBackground">
                      <th class="form-div" style="border-right: solid 1px lightgrey">
                        Récupération
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="width: 100%">
                      <td class="form-div" style="border-right: solid 1px lightgrey">
                        {{
                          convertToFrDateFomat(
                            eventsData[0]["CLD_DATE_LIVRAISON_RETOUR"],
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="mt-1 px-0">
            <v-table style="border: solid 1px lightgrey">
              <thead>
                <tr>
                  <th class="form-div" style="border-right: solid 1px lightgrey">
                    Sous famille
                  </th>
                  <th class="form-div" style="border-right: solid 1px lightgrey">
                    Matricule
                  </th>
                  <th class="form-div" style="border-right: solid 1px lightgrey">
                    Description
                  </th>
                  <!-- <th class="form-div" style="border-right: solid 1px lightgrey">
                    Famille
                  </th> -->
                  <!-- <th class="form-div" style="border-right: solid 1px lightgrey">
                    Marque
                  </th> -->
                  <th class="form-div">Numéro de série</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(mat, i) in eventsData" :key="i">
                  <td class="form-div" style="border-right: solid 1px lightgrey">
                    {{ mat["CLD_SOUS_FAMILLE"] }}
                  </td>
                  <td class="form-div" style="border-right: solid 1px lightgrey">
                    {{ mat["CLD_MATRICULE"] }}
                  </td>
                  <td class="form-div" style="border-right: solid 1px lightgrey">
                    {{ mat["CLD_DESCRIPTION"] }}
                  </td>
                  <!-- <td class="form-div" style="border-right: solid 1px lightgrey">
                    {{ mat["CLD_FAMILLE"] }}
                  </td> -->
                  <!-- <td class="form-div" style="border-right: solid 1px lightgrey">
                    {{ mat["CLD_MARQUE"] }}
                  </td> -->
                  <td class="form-div">
                    {{ mat["CLD_NUMERO_SERIE"] }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div style="font-size: 13px">
              <!-- <v-divider class=""></v-divider> -->
              <v-col v-if="societe" align="center">
                {{ societe["RS"] }} - {{ societe["TypeEntreprise"] }} au capital de
                {{ societe["Capital"] }} € - SIRET {{ societe["NumeroSIRET"] }} - APE :
                {{ societe["CodeAPE"] }} - TVA : {{ societe["TVAIntracommunautaire"] }}
                <br />
                <div v-if="agency">
                  {{ agency["ag_nom"] }} - {{ agency["ag_adresse"] }}
                  {{ agency["ag_cp"] }} {{ agency["ag_ville"] }} - Tél :
                  {{ agency["ag_telephone"] }}
                </div>
              </v-col>
            </div>
            <v-divider class=""></v-divider>
            <v-col align="center" cols="12">
              <v-btn
                variant="flat"
                color="#EF5350"
                style="color: white; width: 100%"
                @click="closeModal"
                >Fermer
              </v-btn>
            </v-col>
            <div align="center" v-if="false">
              <v-btn color="primary" :href="getAccenUrl"> Ouvrir dans ACCEN 55 </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import engine from "@/core/index";

export default {
  data() {
    return {
      isDeleteTransportOpen: false,
      // logoSrc: "data:image/gif;base64,",
      contratData: undefined,
      agency: undefined,
      client: undefined,
      societe: undefined,
      loading: true,
    };
  },
  props: {
    deleteDriver: { type: Function },
    closeModal: { type: Function },
    eventsData: {},
  },
  mounted() {
    console.log("eventsData", this.eventsData);

    let that = this;

    engine.get_contrat_from_num_contrat(
      that.eventsData[0].CLD_NUM_CONTRAT,
      function (data) {
        if (data.code == 0) {
          that.contratData = data.data.data.map((val) => val.fieldData);
          that.contratData = that.contratData[0];
        }
        that.loading = false;
      }
    );

    engine.get_clients(function (data) {
      if (data.code == 0) {
        let result = data.data.data.find(
          (val) => val.fieldData.CL_LIEN == that.eventsData[0].CLD_LIEN
        );
        if (result) {
          that.client = result.fieldData;
          engine.get_societe_by_id_soft(that.client.CL_ID_SOCIETE, function (data) {
            if (data.code == 0) {
              that.societe = data.data.data[0].fieldData;
            }
          });
        }
      }
    });
    engine.get_agency_soft(function (data) {
      if (data.code == 0) {
        let result = data.data.data.find(
          (val) => val.fieldData.ID_Agence == that.eventsData[0].CLD_ID_AGENCE
        );
        if (result) {
          that.agency = result.fieldData;
          // that.logoSrc = String(
          //   that.logoSrc + JSON.parse(that.agency["Logo_JSON"]).Logo_Base64
          // );
        }
      }
    });
  },
  computed: {
    getAccenUrl() {
      // return (
      //   "fmp://demo-accen.dyndns.org/Contrat%20Loc.fmp12?script=affiche_contrat&param=" +
      //   this.eventsData[0]["CLD_NUM_CONTRAT"]
      // );
      return (
        "fmp://demo-accen.dyndns.org/Contrat%20Loc.fmp12?script=affiche_contrat&param=" +
        this.eventsData[0]["CLD_NUM_CONTRAT"]
      );
    },
    getContraDataToShowOnTheTop() {
      let keys = [
        [{ name: "Nom", key: "CL_CLIENT_RAISON_SOCIALE" }],
        [
          { name: "Adresse", key: "CL_CLIENT_ADRESSE" },
          { name: "", key: "CL_CLIENT_COMP_ADRESSE" },
        ],
        [
          { name: "Ville", key: "CL_CLIENT_VILLE" },
          { name: "", key: "CL_CLIENT_CODEPOSTAL" },
        ],
        [{ name: "Contact", key: "CL_CONTACT_LIV" }],
      ];
      return keys;
    },
    getAgencyDataToShow() {
      let keys = [
        "ag_adresse",
        "ag_cp",
        // "ag_ville",
        "ag_telephone",
        "ag_courriel",
        "ag_siteweb",
      ];
      return keys;
    },
  },
  methods: {
    deleteTransport() {
      this.deleteDriver();
      this.closeModal();
    },
    convertToFrDateFomat(date, format) {
      return moment(date).format(format);
    },
  },
};
</script>

<style></style>
